import { render, staticRenderFns } from "./Modalshare.vue?vue&type=template&id=08c41b7d&"
import script from "./Modalshare.vue?vue&type=script&lang=js&"
export * from "./Modalshare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports